import { LogOut, CircleUserRound } from 'lucide-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import Avatar from '@/components/blocks/Avatar';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/common/Dropdown/Elements';
import { useUserSession } from '@/contexts/UserSession';

const Profile = () => {
    const { t } = useTranslation('common');
    const { user, logout } = useUserSession();
    const menuItems = useMemo(
        () => [
            {
                name: t('common:profile.profile'),
                icon: CircleUserRound,
                href: '/profile',
            },
        ],
        [t]
    );

    return (
        <DropdownMenu>
            <DropdownMenuTrigger data-cy="avatarAction" asChild className="cursor-pointer">
                <div>
                    <Avatar name={user?.name} />
                </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="p-0" align="end">
                <DropdownMenuLabel className="mb-1 flex items-center gap-2 p-3">
                    <Avatar name={user?.name} />
                    <div>
                        <div className="text-default-800 text-sm font-medium capitalize">{user?.name}</div>
                        <div className="text-default-600 hover:text-primary pr-2 text-xs">{user?.email}</div>
                    </div>
                </DropdownMenuLabel>
                {menuItems.map((item, index) => (
                    <Link to={item.href} key={`info-menu-${index}`} className="cursor-pointer">
                        <DropdownMenuItem className="text-default-600 flex cursor-pointer items-center gap-2 px-3 py-1.5 text-sm font-medium capitalize">
                            <item.icon className="h-4 w-4" />
                            {item.name}
                        </DropdownMenuItem>
                    </Link>
                ))}
                <DropdownMenuSeparator />
                <DropdownMenuItem
                    onSelect={() => logout()}
                    className="text-default-600 my-1 flex cursor-pointer items-center gap-2 px-3 text-sm font-medium capitalize"
                >
                    <LogOut className="h-4 w-4" />
                    {t('common:profile.logout')}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
export default Profile;
